import axios from 'axios';

let inMemoryBearerToken = '';

export function setApiBearerToken(token) {
  inMemoryBearerToken = token || '';
}

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use(config => {
  if (inMemoryBearerToken) {
    config.headers.Authorization = `Bearer ${inMemoryBearerToken}`;
  }
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401 && typeof window !== 'undefined' && !error.config?.skipAuthExpiredEvent) {
      window.dispatchEvent(new Event('kitchen-auth-expired'));
    }
    return Promise.reject(error);
  }
);

export default api;

